import {Component, Input, ViewEncapsulation} from '@angular/core';

/**
 * la-empty
 */
@Component({
  selector: 'la-empty',
  template: `
    <div class="la-empty">
      <div class="la-empty__img">
        <la-image [src]="'assets/images/generic-empty-state.png'"></la-image>
        <la-icon [name]="name" [size]="'xlarge'" [color]="'white'"></la-icon>
      </div>
      <ng-content></ng-content>
    </div>`,
  styles: [`
    @font-face{font-family:NeueHaasGrotDisp-45Light;font-style:normal;font-weight:300;src:url(assets/fonts/NeueHaasGrotDisp-45Light.woff) format("woff")}@font-face{font-family:NeueHaasGrotDisp-55Roman;font-style:normal;font-weight:400;src:url(assets/fonts/NeueHaasGrotDisp-55Roman.woff) format("woff")}@font-face{font-family:NeueHaasUnicaPro;font-style:normal;font-weight:400;src:url(assets/fonts/NeueHaasUnicaPro-Regular.woff) format("woff")}@font-face{font-family:NeueHaasUnicaPro;font-style:normal;font-weight:500;src:url(assets/fonts/NeueHaasUnicaPro-Medium.woff) format("woff")}.la-empty{text-align:center}.la-empty__img{margin:auto;display:block;position:relative;width:148px;height:131px}.la-empty__img la-icon{position:absolute;top:46px;left:54px}.la-empty la-text:nth-child(2){display:block;padding-top:24px;color:#031422}.la-empty la-text:nth-child(3){padding-top:4px;display:block;color:rgba(3,20,34,.4)}
  `],
  encapsulation: ViewEncapsulation.None
})
export class LaEmptyComponent {
  private _name: string;

  /**
   * name for set icon
   */
  @Input()
  set name(name: string) {
    this._name = name;
  }

  get name(): string {
    return this._name;
  }
}
